import { cn } from '../../lib/utils'

const variants = {
  primary:   'bg-primary text-white hover:opacity-90',
  secondary: 'bg-primary-light text-primary hover:bg-primary hover:text-white',
  ghost:     'bg-transparent text-text-secondary hover:bg-background',
  danger:    'bg-rose-500 text-white hover:bg-rose-600',
}

const sizes = {
  sm: 'px-3 py-1.5 text-sm',
  md: 'px-4 py-2.5 text-sm',
  lg: 'px-6 py-3 text-base',
}

export const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  className,
  disabled,
  ...props
}) => (
  <button
    className={cn(
      'inline-flex items-center justify-center gap-2 rounded-base font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:opacity-50 disabled:cursor-not-allowed',
      variants[variant],
      sizes[size],
      className
    )}
    disabled={disabled}
    {...props}
  >
    {children}
  </button>
)
